/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import axios from 'axios';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function getUrl(token) {
    const base = '/api/v1/settings/notification_settings/';
    if (token != null) {
        return `${base}?token=${token}`;
    }
    return base;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class NotificationSetting {
    // eslint-disable-next-line
    constructor(reason, explanation, value) {
        this.reason = reason;
        this.explanation = explanation;
        this.value = value;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        return new NotificationSetting(data.reason, data.explanation, data.value);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    updateValue(newValue, token = null) {
        return axios
            .patch(getUrl(token), {
            reason: this.reason,
            value: newValue,
        })
            .then(() => {
            this.value = newValue;
        });
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class NotificationSettings {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(settings, possibleValues) {
        this.settings = settings;
        this.possibleValues = possibleValues;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static async loadFromServer(token = null) {
        const url = getUrl(token);
        const { data } = await axios.get(url);
        return new NotificationSettings(data.options.map(NotificationSetting.fromServerData), data.possible_values);
    }
}
